import { ProfileDto } from '@eventr/common'
import {
    MobileConfirmDialog,
    RequiredActionDialog,
    TermsNotAcceptedProps,
    useDialogStore,
} from '@eventr/common-storybook'
import { bs } from '../../state/bound.store'

export const checkForTermsAndConditions = async (profile: ProfileDto) => {
    if (profile === undefined) {
        return
    }
    if (profile.termsConditionsAcceptedUnix === 0) {
        useDialogStore.getState().replaceDialog({
            node: (
                <RequiredActionDialog
                    {...TermsNotAcceptedProps}
                    marketingOptIn={profile.marketingAcceptedUnix > 0}
                    onConfirm={async () => {
                        await bs().updateRequest({ termsAccepted: true })
                        useDialogStore.getState().clearDialog()
                    }}
                    onCancel={async () => {
                        useDialogStore.getState().replaceDialog({
                            node: (
                                <MobileConfirmDialog
                                    text="Are you sure you want to decline these necessary terms? Doing so will log you out and prevent you from using EventR."
                                    header="Decline Terms of Service"
                                    onCancel={() => {
                                        checkForTermsAndConditions(profile)
                                    }}
                                    onConfirm={() => {
                                        bs().logout()
                                        useDialogStore.getState().clearDialog()
                                    }}
                                    confirmText="Decline"
                                />
                            ),
                            backdropClosable: false,
                        })
                    }}
                    onMarketingOptInChange={(value) => {
                        bs().updateRequest({ marketingOptIn: value })
                    }}
                />
            ),
            backdropClosable: false,
        })
    }
}
